import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AttritionService } from '../../../../services/attrition.service';
import { SettingsService } from '../../../../services/settings.service';

@Component({
  selector: 'app-attrition-form',
  imports: [CommonModule, FormsModule],
  providers: [AttritionService, ToastrService],
  templateUrl: './attrition-form.component.html',
  styleUrl: './attrition-form.component.scss'
})
export class AttritionFormComponent implements OnInit {
  attrition: any = {};
  settingsRaw: any[] = [];
  positionOptions: any[] = [];
  statusOptions: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private attritionService: AttritionService,
    private settingsService: SettingsService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.attritionService.getAttritionById(+id).subscribe((data: any) => {
          this.attrition = data;
        });
      }
    });

    this.settingsService.getSettings().subscribe({
      next: (settings) => {
        this.settingsRaw = Array.isArray(settings) ? settings : (settings.data || []);
        this.statusOptions = this.settingsRaw.filter(s => s.code === 'status');
      },
      error: (err) => {
        // Handle error as needed
        console.error('Failed to load settings', err);
      }
    });
  }

  onSubmit(form: any) {
    console.log('Form submitted:', form.value);
    if (this.attrition && this.attrition.id) {
      this.attritionService.updateAttrition(this.attrition.id, form.value).subscribe({
        next: (response) => {
          this.toastr.success('Attrition updated successfully!', 'Success');
          this.router.navigate(['/reports']);
        },
        error: (err) => {
          this.toastr.error('Failed to update attrition.', 'Error');
          console.error('Failed to update attrition', err);
        }
      });
    } else {
      this.toastr.error('No attrition ID found, cannot update.', 'Error');
      console.warn('No attrition ID found, cannot update.');
    }
  }

  onCancel() {
    this.router.navigate(['/reports']);
  }
}
